import { Button, Flex, Modal, Text } from '@mantine/core';
import { FC, useLayoutEffect, useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { SavedCreatorState } from '@/types/creator';
import { lockedCollectionId, presetId } from '@/components/App';
import APP_CONFIG from '@/configs/appConfig';
import { useContent } from '@/providers/ContentProvider';

const baseSlug = 'restoreProjectModal.';

export const RestoreProjectModal: FC = () => {
	const dispatch = useTypedDispatch();
	const { options } = useTypedSelector((state) => state.creator);

	const { getContent } = useContent();

	const [isOpen, modalControls] = useDisclosure();

	const [payload, setPayload] = useState<SavedCreatorState | null>(null);

	useLayoutEffect(() => {
		if (import.meta.env.DEV) return;
		if (options.isPreviewMode) return;
		if (options.isPresetMode) return;
		if (lockedCollectionId || presetId) return;

		const tempPrpoject = localStorage.getItem(
			APP_CONFIG.TEMP_PROJECT_STORAGE_KEY
		);

		if (!tempPrpoject) return;
		modalControls.open();

		try {
			const payload = JSON.parse(tempPrpoject);
			setPayload(payload);
		} catch (error) {
			console.error('INVALID_PAYLOAD', error);
		}
	}, []);

	const handleClose = () => {
		modalControls.close();
		localStorage.removeItem(APP_CONFIG.TEMP_PROJECT_STORAGE_KEY);
	};

	const handleRestore = () => {
		if (!payload) return;

		dispatch(creatorActions.loadProject(payload));
		setPayload(null);
		handleClose();
	};

	return (
		<Modal
			opened={isOpen}
			onClose={handleClose}
			title={getContent(`${baseSlug}title`)}
			size="md"
		>
			<Text mb="md" c="dimmed">
				{getContent(`${baseSlug}message`)}
			</Text>
			<Flex gap="md">
				<Button fullWidth color="black" onClick={handleClose}>
					{getContent(`${baseSlug}startFresh`)}
				</Button>
				<Button fullWidth onClick={handleRestore} color="green">
					{getContent(`${baseSlug}restore`)}
				</Button>
			</Flex>
		</Modal>
	);
};
